/* wsapi3-animate-on-scroll v1.0 */
/* Deploy Version 2026-10-07 15:51:43 */
/* Deploy Version 2026-09-24 19:11:08 */
/* wsapi3-animate-on-scroll v1.0 — 2026-09-10

   Reescrita do módulo legado ws-library-animate-on-scroll (que empacotava a lib
   AOS 2.x inteira). Ver a análise em [[project-wsapi3-animate-on-scroll]] e a
   skill "animation".

   O que mudou em relação ao AOS:
     - 1 IntersectionObserver compartilhado, sem MutationObserver global na árvore
       inteira do documento (o AOS re-escaneava tudo a cada mutação → forced reflow);
     - nunca lê offsetTop/offsetLeft (o AOS lia num loop por elemento em init/resize/
       refresh → layout síncrono forçado);
     - `once` é o DEFAULT (o AOS vinha com once:false → trabalho de scroll perpétuo
       re-escondendo/re-animando pra sempre);
     - inicializa no DOMContentLoaded, não num setTimeout(1000) empilhado no load;
     - respeita prefers-reduced-motion;
     - se algo falhar, o conteúdo fica VISÍVEL (nunca preso em opacity:0).

   Só mexe em opacity/transform → não afeta CLS.

   API pública: window.WsAnimateOnScroll.start() / .refresh()
   - refresh(): rechama observe em [data-wsaos] novos. Um módulo que injeta
     conteúdo client-side (SSR hydration, grid dinâmico) chama isso depois de
     inserir o HTML. Não é automático de propósito. */

(function () {
  'use strict';

  var HTML = document.documentElement;
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var SUPPORTED = typeof IntersectionObserver !== 'undefined';

  var observer = null;
  var started = false;

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  function revealAll() {
    each(document.querySelectorAll('[data-wsaos]'), function (el) {
      el.classList.add('wsaos-in');
    });
  }

  // Overrides por elemento (data-wsaos-duration / -delay / -distance), aplicados 1x.
  function prime(el) {
    if (el.__wsaosPrimed) return;
    el.__wsaosPrimed = true;

    var dur = parseInt(el.getAttribute('data-wsaos-duration'), 10);
    var delay = parseInt(el.getAttribute('data-wsaos-delay'), 10);
    var dist = parseInt(el.getAttribute('data-wsaos-distance'), 10);
    if (dur > 0) el.style.setProperty('--wsaos-dur', dur + 'ms');
    if (delay > 0) el.style.setProperty('--wsaos-delay', delay + 'ms');
    if (dist > 0) el.style.setProperty('--wsaos-dist', dist + 'px');
  }

  // --wsaos-i nos filhos diretos [data-wsaos] de cada [data-wsaos-stagger].
  function setStaggerIndexes() {
    each(document.querySelectorAll('[data-wsaos-stagger]'), function (group) {
      var i = 0;
      each(group.children, function (child) {
        if (child.hasAttribute('data-wsaos')) {
          child.style.setProperty('--wsaos-i', i++);
        }
      });
    });
  }

  function onIntersect(entries) {
    each(entries, function (entry) {
      var el = entry.target;
      var once = el.getAttribute('data-wsaos-once') !== 'false';

      if (entry.isIntersecting) {
        el.classList.add('wsaos-in');
        if (once) observer.unobserve(el);
      } else if (!once && el.classList.contains('wsaos-in')) {
        // só re-esconde quando o dev pediu data-wsaos-once="false" de propósito
        el.classList.remove('wsaos-in');
      }
    });
  }

  function observeAll() {
    each(document.querySelectorAll('[data-wsaos]:not(.wsaos-in)'), function (el) {
      prime(el);
      observer.observe(el);
    });
  }

  // Rede de segurança: 3s depois, o que ainda estiver escondido E dentro da
  // viewport é revelado (cobre observer que não disparou por qualquer motivo).
  function failsafe() {
    var vh = window.innerHeight || HTML.clientHeight || 0;
    each(document.querySelectorAll('[data-wsaos]:not(.wsaos-in)'), function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('wsaos-in');
    });
  }

  function start() {
    if (started) return true;
    started = true;

    if (!document.querySelector('[data-wsaos]')) return true; // nada a animar

    HTML.classList.add('wsaos-on');

    // reduced-motion ou browser sem IntersectionObserver: revela tudo, sem esconder
    if (REDUCE || !SUPPORTED) {
      revealAll();
      return true;
    }

    setStaggerIndexes();
    observer = new IntersectionObserver(onIntersect, {
      // dispara um pouco antes do topo entrar de fato → anima já visível, sem "pop"
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.01
    });
    observeAll();
    setTimeout(failsafe, 3000);

    return true;
  }

  function refresh() {
    if (!observer) return;
    setStaggerIndexes();
    observeAll();
  }

  window.WsAnimateOnScroll = { start: start, refresh: refresh };

  // Participa do relatório de módulos / isOk quando o wsMain existe...
  if (typeof wsMain !== 'undefined' && wsMain && typeof wsMain.createModule === 'function') {
    wsMain.createModule({
      name: 'animate-on-scroll',
      version: '1.0',
      updatedAt: '2026-09-10',
      function: 'init',
      init: function () {
        return start(); // no-op idempotente se já iniciou no DOMContentLoaded
      }
    });
  }

  // ...mas não espera o wsMain.exec() (que roda no window 'load', tarde demais):
  // inicializa já no DOMContentLoaded pra o observer estar de pé antes de o
  // usuário rolar a página.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      try { start(); } catch (e) {}
    }, { once: true });
  } else {
    try { start(); } catch (e) {}
  }
})();
